<template>
  <div>
    <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
            <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
              v-clipboard:success="onCopy" v-clipboard:error="onError"><i class="fa fa-copy mr-1" />Copy!
            </b-dropdown-item>
            <b-dropdown-item @click="checkDataExcel(json_data)">
              <download-excel :data="json_data" :fields="json_fields" :name="getNameExport(this.withdrawType)">
                <i class="fa fa-file-excel-o mr-1" />Export Excel Select
              </download-excel>
            </b-dropdown-item>
            <b-dropdown-item>
              <download-excel :data="dataExport" :fields="json_fields" :name="getNameExport(this.withdrawType)">
                <i class="fa fa-file-excel-o mr-1" />Export Excel All
              </download-excel>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <a-checkbox @change="getAutoRefresh(refresh)">
              รีเฟรชอัตโนมัติ {{(this.refresh) ? myVal : ''}}
          </a-checkbox>
        </div>
        <div class="d-flex flex-column justify-content-center">
            <a class="btn btn-primary" href="javascript: void(0);" @click="getDataStatement()"><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
        </div>
    </div>
    <a-tabs default-active-key="1" v-model="activeKey" @change="callback">
      <a-tab-pane v-for="pane in panes" :key="pane.key" :tab="pane.title" >
        <!-- <span slot="tab">
          <a-icon type="check" />
          ปกติ
        </span> -->
        <a-table :columns="columns" :dataSource="dataTable" rowKey='bankPaymentId' :row-selection="rowSelection"
          :loading="loadingTable" :scroll="{ x: 1500 }" :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
          <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown">
            <a-input v-ant-ref="c => searchInput = c" :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]" @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
              style="width: 188px; margin-bottom: 8px; display: block;" />
            <a-button type="primary" @click="() => handleSearch(selectedKeys, confirm)" size="small"
              style="width: 90px; margin-right: 8px">
              Search
            </a-button>
            <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px">
              Reset
            </a-button>
          </div>
          <a-icon slot="filterIcon" slot-scope="filtered" type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }" />
          <a slot="actionAmountInCome" slot-scope="text, record"
            :style="setColor('amountIn')">{{setComma(record.amountInCome)}}</a>
          <a slot="actionAmountOutCome" slot-scope="text, record"
            :style="setColor('amountOut')">{{setComma(record.amountOutCome)}}</a>
          <h6 slot="status" slot-scope="status, record">
            <b-badge href="#" @click="useAction(record.bankPaymentId,status)" :row-selection="rowSelection"
              :loading="isloading" pill :variant="getStatus('bankPayment',status).color">
              {{getStatus('bankPayment',status).name}}
            </b-badge>
            <b-badge v-if="record.createdBy !== null && record.moneyTranferSlip === null" href="#" @click="useAction(record.bankPaymentId,status)" :row-selection="rowSelection"
              :loading="isloading" pill :variant="getStatus('bankPaymentCreated',1).color">
              {{getStatus('bankPaymentCreated',1).name}} : {{record.bankPaymentTypeName}}</b-badge>
              <b-badge v-else-if="record.createdBy !== null && record.moneyTranferSlip !== null" href="#" @click="useAction(record.bankPaymentId,status)" :row-selection="rowSelection"
              :loading="isloading" pill :variant="getStatus('bankPaymentCreated',2).color">
              {{getStatus('bankPaymentCreated',2).name}} : {{record.bankPaymentTypeName}}</b-badge>
              <b-badge v-else-if="record.createdBy === null && record.moneyTranferSlip !== null" href="#" @click="useAction(record.bankPaymentId,status)" :row-selection="rowSelection"
              :loading="isloading" pill :variant="getStatus('bankPaymentCreated',3).color">
              {{getStatus('bankPaymentCreated',3).name}} : {{record.bankPaymentTypeName}}</b-badge>

          </h6>
        </a-table>
      </a-tab-pane>
      <!-- <a-tab-pane key="2">
        <span slot="tab">
          <a-icon type="exclamation" />
          มีปัญหา
        </span>
        Tab 2
      </a-tab-pane> -->
    </a-tabs>
    <!-- <a-modal v-model="modelShowDetail" title="ข้อมูลรายการที่จับคู่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModal">
      <div class="mb-5">
        <h5 class="mb-4">
          <strong>รายละเอียดรายการที่จับคู่กับ # {{(!this.datatransection.bankPaymentId)?"ไม่พบข้อมูล":this.datatransection.bankPaymentId }}</strong>
        </h5>
        <a-skeleton :active="loadingModal" :loading="loadingActive" />
        <dl class="row" v-if="loadingModal !== true">
          <dt class="col-sm-3">รหัสรายการ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.depositCode)?"ไม่พบข้อมูล":this.datatransection.depositCode }}</dd>

          <dt class="col-sm-3">บัญชีลูกค้า :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.userBankTranfer)?"ไม่พบข้อมูล":this.datatransection.userBankTranfer }}</dd>

          <dt class="col-sm-3">บัญชีระบบ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.systemBankTranfer)?"ไม่พบข้อมูล":this.datatransection.systemBankTranfer }}</dd>

          <dt class="col-sm-3 text-truncate">จำนวนเงิน :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.amount)?"ไม่พบข้อมูล":this.datatransection.amount }}</dd>

          <dt class="col-sm-3">สถานะ :</dt>
          <dd class="col-sm-9"><b-badge pill :variant="(!this.datatransection.color)?'info':this.datatransection.color">{{(!this.datatransection.status)?"ไม่พบข้อมูล":this.datatransection.status }}</b-badge>
              <b-badge v-if="this.datatransection.adminCreateUsername !== null && this.datatransection.adminApprovePayUsername === null"
              :variant="getStatus('bankPaymentCreated',1).color">
              {{getStatus('bankPaymentCreated',1).name}}</b-badge>
              <b-badge v-else-if="this.datatransection.adminCreateUsername !== null && this.datatransection.adminApprovePayUsername !== null"
               :variant="getStatus('bankPaymentCreated',2).color">
              {{getStatus('bankPaymentCreated',2).name}}</b-badge></dd>
          <dt class="col-sm-3">หมายเหตุ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.remark)?"ไม่พบข้อมูล":this.datatransection.remark }}</dd>

          <dt class="col-sm-3">สร้างโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.adminCreateUsername)?"ไม่พบข้อมูล":this.datatransection.adminCreateUsername }}</dd>

          <dt class="col-sm-3">อนุมัติโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.adminApprovePayUsername)?"ไม่พบข้อมูล":this.datatransection.adminApprovePayUsername }}</dd>
        </dl>
      </div>
    </a-modal>
    <a-modal v-model="modelShowDetail2" title="ข้อมูลรายการที่จับคู่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModal2">
      <div class="mb-5">
        <h5 class="mb-4">
          <strong>รายละเอียดรายการที่จับคู่กับ # {{(!this.datatransection2.bankPaymentId)?"ไม่พบข้อมูล":this.datatransection2.bankPaymentId }}</strong>
        </h5>
        <a-skeleton :active="loadingModal" :loading="loadingActive" />
        <dl class="row" v-if="loadingModal !== true">
          <dt class="col-sm-3">รหัส Tranfer :</dt>
          <dd class="col-sm-9">{{(!this.datatransection2.depositCode)?"ไม่พบข้อมูล":this.datatransection2.depositCode }}</dd>

          <dt class="col-sm-3">บัญชีรับเงิน :</dt>
          <dd class="col-sm-9">{{(!this.datatransection2.userBankTranfer)?"ไม่พบข้อมูล":this.datatransection2.userBankTranfer }}</dd>

          <dt class="col-sm-3">บัญชีโยกเงิน :</dt>
          <dd class="col-sm-9">{{(!this.datatransection2.systemBankTranfer)?"ไม่พบข้อมูล":this.datatransection2.systemBankTranfer }}</dd>

          <dt class="col-sm-3 text-truncate">จำนวนเงิน :</dt>
          <dd class="col-sm-9">{{(!this.datatransection2.amount)?"ไม่พบข้อมูล":this.datatransection2.amount }}</dd>

          <dt class="col-sm-3">สถานะ :</dt>
          <dd class="col-sm-9"><b-badge pill :variant="(!this.datatransection2.color)?'info':this.datatransection2.color">{{(!this.datatransection2.status)?"ไม่พบข้อมูล":this.datatransection2.status }}</b-badge>
                              <b-badge v-if="this.datatransection2.adminCreateUsername !== null && this.datatransection2.adminApprovePayUsername === null"
                              :variant="getStatus('bankPaymentCreated',1).color">
                              {{getStatus('bankPaymentCreated',1).name}}</b-badge>
                              <b-badge v-else-if="this.datatransection2.adminCreateUsername !== null && this.datatransection2.adminApprovePayUsername !== null"
                              :variant="getStatus('bankPaymentCreated',2).color">
                              {{getStatus('bankPaymentCreated',2).name}}</b-badge>
          </dd>

          <dt class="col-sm-3">หมายเหตุ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection2.remark)?"ไม่พบข้อมูล":this.datatransection2.remark }}</dd>

          <dt class="col-sm-3">สร้างโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection2.adminCreateUsername)?"ไม่พบข้อมูล":this.datatransection2.adminCreateUsername }}</dd>

          <dt class="col-sm-3">อนุมัติโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection2.adminApprovePayUsername)?"ไม่พบข้อมูล":this.datatransection2.adminApprovePayUsername }}</dd>
        </dl>
      </div>
    </a-modal>
    <a-modal v-model="modelShowDetail3" title="ข้อมูลรายการที่จับคู่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModal3">
      <div class="mb-5">
        <h5 class="mb-4">
          <strong>รายละเอียดรายการที่จับคู่กับ # {{(!this.datatransection3.bankPaymentId)?"ไม่พบข้อมูล":this.datatransection3.bankPaymentId }}</strong>
        </h5>
        <a-skeleton :active="loadingModal" :loading="loadingActive" />
        <div class="row" v-if="loadingModal !== true">
          <dt class="col-sm-3">รหัสรายการ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection3.bankPaymentId)?"ไม่พบข้อมูล":this.datatransection3.bankPaymentId }}</dd>

          <dt class="col-sm-3">บัญชีระบบ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection3.systemBankTranfer)?"ไม่พบข้อมูล":this.datatransection3.systemBankTranfer }}</dd>

          <dt class="col-sm-3 text-truncate">จำนวนเงิน :</dt>
          <dd class="col-sm-9">{{(!this.datatransection3.amount)?"ไม่พบข้อมูล":this.datatransection3.amount }}</dd>

          <dt class="col-sm-3">สถานะ :</dt>
          <dd class="col-sm-9"><b-badge pill :variant="(!this.datatransection3.color)?'info':this.datatransection3.color">{{(!this.datatransection3.status)?"ไม่พบข้อมูล":this.datatransection3.status }}</b-badge>
                              <b-badge v-if="this.datatransection3.adminCreateUsername !== null && this.datatransection3.adminApprovePayUsername === null"
                              :variant="getStatus('bankPaymentCreated',1).color">
                              {{getStatus('bankPaymentCreated',1).name}}</b-badge>
                              <b-badge v-else-if="this.datatransection3.adminCreateUsername !== null && this.datatransection3.adminApprovePayUsername !== null"
                              :variant="getStatus('bankPaymentCreated',2).color">
                              {{getStatus('bankPaymentCreated',2).name}}</b-badge>
                              <b-badge v-else-if="this.datatransection3.adminCreateUsername === null && this.datatransection3.dataImg !== null"
                              :variant="getStatus('bankPaymentCreated',3).color">
                              {{getStatus('bankPaymentCreated',3).name}}</b-badge>
          </dd>

          <dt class="col-sm-3">หมายเหตุ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection3.remark)?"ไม่พบข้อมูล":this.datatransection3.remark }}</dd>
          <dt class="col-sm-3">สร้างโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection3.adminCreateUsername)?"ไม่พบข้อมูล":this.datatransection3.adminCreateUsername }}</dd>

          <dt class="col-sm-3">อนุมัติโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection3.adminApprovePayUsername)?"ไม่พบข้อมูล":this.datatransection3.adminApprovePayUsername }}</dd>
          <dt class="col-sm-3">แก้สถานะ :</dt>
          <dd class="col-sm-9"> <a class="btn btn-warning" href="javascript: void(0);" @click="reStatusBankPayment('datatransection3')"> ยกเลิกรายการปรับสถานะ {{this.datatransection3.bankPaymentId}}</a></dd>
          <dt class="col-sm-3 text-truncate">สลิปหลักฐาน :</dt>
          <dd class="col-sm-9" v-if="this.datatransection3.dataImg !== null">
            <a-upload
              action="#"
              listType="picture-card"
              :fileList="this.datatransection3.moneyTranferSlip.fileList"
              style="width: 100%"
              @preview="handlePreview"
            >
            </a-upload>
          </dd>
          <dd class="col-sm-9" v-else>ไม่พบข้อมูล</dd>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="modelShowDetail4" title="ข้อมูลรายการที่จับคู่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModal4">
      <div class="mb-5">
        <h5 class="mb-4">
          <strong>รายละเอียดรายการที่จับคู่กับ # {{(!this.datatransection4.bankPaymentId)?"ไม่พบข้อมูล":this.datatransection4.bankPaymentId }}</strong>
        </h5>
        <a-skeleton :active="loadingModal" :loading="loadingActive" />
        <dl class="row" v-if="loadingModal !== true">
          <dt class="col-sm-3">รหัสรายการ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection4.depositCode)?"ไม่พบข้อมูล":this.datatransection4.depositCode }}</dd>

          <dt class="col-sm-3">บัญชีลูกค้า :</dt>
          <dd class="col-sm-9">{{(!this.datatransection4.userBankTranfer)?"ไม่พบข้อมูล":this.datatransection4.userBankTranfer }}</dd>

          <dt class="col-sm-3">บัญชีระบบ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection4.systemBankTranfer)?"ไม่พบข้อมูล":this.datatransection4.systemBankTranfer }}</dd>

          <dt class="col-sm-3 text-truncate">จำนวนเงิน :</dt>
          <dd class="col-sm-9">{{(!this.datatransection4.amount)?"ไม่พบข้อมูล":this.datatransection4.amount }}</dd>

          <dt class="col-sm-3">สถานะ :</dt>
          <dd class="col-sm-9"><b-badge pill :variant="(!this.datatransection4.color)?'info':this.datatransection4.color">{{(!this.datatransection4.status)?"ไม่พบข้อมูล":this.datatransection4.status }}</b-badge>
                              <b-badge v-if="this.datatransection4.adminCreateUsername !== null && this.datatransection4.adminApprovePayUsername === null"
                              :variant="getStatus('bankPaymentCreated',1).color">
                              {{getStatus('bankPaymentCreated',1).name}}</b-badge>
                              <b-badge v-else-if="this.datatransection4.adminCreateUsername !== null && this.datatransection4.adminApprovePayUsername !== null"
                              :variant="getStatus('bankPaymentCreated',2).color">
                              {{getStatus('bankPaymentCreated',2).name}}</b-badge>
                              <b-badge v-else-if="this.datatransection4.adminCreateUsername === null && this.datatransection4.dataImg !== null"
                              :variant="getStatus('bankPaymentCreated',3).color">
                              {{getStatus('bankPaymentCreated',3).name}}</b-badge>
          </dd>

          <dt class="col-sm-3">หมายเหตุ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection4.remark)?"ไม่พบข้อมูล":this.datatransection4.remark }}</dd>
          <dt class="col-sm-3 text-truncate">สลิปหลักฐาน :</dt>
          <dd class="col-sm-9" v-if="this.datatransection4.dataImg !== null">
            <a-upload
            action="#"
            listType="picture-card"
            :fileList="this.datatransection4.moneyTranferSlip.fileList"
            @preview="handlePreview"
          ></a-upload></dd>
          <dd class="col-sm-9" v-else>ไม่พบข้อมูล</dd>

          <dt class="col-sm-3">สร้างโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection4.adminCreateUsername)?"ไม่พบข้อมูล":this.datatransection4.adminCreateUsername }}</dd>

          <dt class="col-sm-3">อนุมัติโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection4.adminApprovePayUsername)?"ไม่พบข้อมูล":this.datatransection4.adminApprovePayUsername }}</dd>
        </dl>
      </div>
    </a-modal> -->
    <a-modal v-model="modelShowDetail" title="ข้อมูลรายการที่จับคู่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModal">
      <div class="mb-5">
        <h5 class="mb-4">
          <strong>รายละเอียดสเตทเม้น # {{(!this.datatransection.bankPaymentId)?"ไม่พบข้อมูล":this.datatransection.bankPaymentId }}</strong>
        </h5>
        <a-skeleton :active="loadingModal" :loading="loadingActive" />
        <dl class="row" v-if="loadingModal !== true">
          <dt class="col-sm-3">{{(this.datatransection.statementStatus === 'tranfer')?"รหัส Tranfer":"รหัสรายการ" }}  :</dt>
          <dd class="col-sm-9" v-if="this.datatransection.statementStatus === 'Not Type'">{{(!this.datatransection.bankPaymentId)?"ไม่พบข้อมูล":this.datatransection.bankPaymentId }}</dd>
          <dd class="col-sm-9" v-else>{{(!this.datatransection.depositCode)?"ไม่พบข้อมูล":this.datatransection.depositCode }}</dd>

          <dt class="col-sm-3">บัญชีลูกค้า :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.userBankTranfer)?"ไม่พบข้อมูล":this.datatransection.userBankTranfer }}</dd>

          <dt class="col-sm-3">บัญชีระบบ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.systemBankTranfer)?"ไม่พบข้อมูล":this.datatransection.systemBankTranfer }}</dd>

          <dt class="col-sm-3 text-truncate">จำนวนเงิน :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.amount)?"ไม่พบข้อมูล":this.datatransection.amount }}</dd>

          <dt class="col-sm-3">สถานะ :</dt>

          <dd class="col-sm-9" v-if="this.datatransection.statementStatus === 'deposit' || this.datatransection.statementStatus === 'depositFront' || this.datatransection.statementStatus === 'withdraw' || this.datatransection.statementStatus === 'withdrawFront' || this.datatransection.statementStatus === 'tranfer' ">
            <b-badge pill :variant="(!this.datatransection.color)?'info':this.datatransection.color">
              {{(!this.datatransection.status)?"ไม่พบข้อมูล":this.datatransection.status }}</b-badge>
            <b-badge
              v-if="this.datatransection.adminCreateUsername !== null && this.datatransection.adminApprovePayUsername === null"
              :variant="getStatus('bankPaymentCreated',1).color">
              {{getStatus('bankPaymentCreated',1).name}}</b-badge>
            <b-badge
              v-else-if="this.datatransection.adminCreateUsername !== null && this.datatransection.adminApprovePayUsername !== null"
              :variant="getStatus('bankPaymentCreated',2).color">
              {{getStatus('bankPaymentCreated',2).name}}</b-badge>
              <!-- <b-badge v-else :disabled="true"></b-badge> -->
          </dd>

          <dd class="col-sm-9" v-else-if="this.datatransection.statementStatus === 'bankPayment'">
              <b-badge pill :variant="(!this.datatransection.color)?'info':this.datatransection.color">
              {{(!this.datatransection.status)?"ไม่พบข้อมูล":this.datatransection.status }}</b-badge>
            <b-badge
              v-if="this.datatransection.adminCreateUsername !== null && this.datatransection.adminApprovePayUsername === null"
              :variant="getStatus('bankPayment',1).color">
              {{getStatus('bankPayment',1).name}}</b-badge>
            <b-badge
              v-else-if="this.datatransection.adminCreateUsername !== null && this.datatransection.adminApprovePayUsername !== null"
              :variant="getStatus('bankPayment',2).color">
              {{getStatus('bankPayment',2).name}}</b-badge>
            <b-badge
              v-else-if="this.datatransection.adminCreateUsername === null && this.datatransection.dataImg !== null"
              :variant="getStatus('bankPayment',3).color">
              {{getStatus('bankPayment',3).name}}</b-badge>
              <!-- <b-badge v-else :disabled="true"></b-badge> -->
          </dd>

          <dd class="col-sm-9" v-else-if="this.datatransection.statementStatus === 'Not Type'">
              <b-badge> ไม่พบข้อมูล</b-badge>
          </dd>

          <dd class="col-sm-9" v-else>
              <b-badge pill :variant="(!this.datatransection.color)?'info':this.datatransection.color">
                {{(!this.datatransection.status)?"ไม่พบข้อมูล":this.datatransection.status }}</b-badge>
              <b-badge
                v-if="this.datatransection.adminCreateUsername !== null && this.datatransection.adminApprovePayUsername === null"
                :variant="getStatus('bankPaymentCreated',1).color">
                {{getStatus('bankPaymentCreated',1).name}}</b-badge>
              <b-badge
                v-else-if="this.datatransection.adminCreateUsername !== null && this.datatransection.adminApprovePayUsername !== null"
                :variant="getStatus('bankPaymentCreated',2).color">
                {{getStatus('bankPaymentCreated',2).name}}</b-badge>
              <b-badge
                v-else-if="this.datatransection.adminCreateUsername === null && this.datatransection.datImg !== null"
                :variant="getStatus('bankPaymentCreated',3).color">
                {{getStatus('bankPaymentCreated',3).name}}</b-badge>
              <!-- <b-badge v-else :disabled="true"></b-badge> -->
          </dd>

          <dt class="col-sm-3">หมายเหตุ :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.remark)?"ไม่พบข้อมูล":this.datatransection.remark }}</dd>

          <dt class="col-sm-3">สร้างโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.adminCreateUsername)?"ไม่พบข้อมูล":this.datatransection.adminCreateUsername }}</dd>

          <dt class="col-sm-3">อนุมัติโดย :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.adminApprovePayUsername)?"ไม่พบข้อมูล":this.datatransection.adminApprovePayUsername }}</dd>

          <dt class="col-sm-3">{{(this.pageType === 'deposit' || this.pageType === 'depositFront') ? 'สร้างรายการเติมเงิน' : 'อนุมัติถอน'}} :</dt>
          <dd class="col-sm-9">{{(!this.datatransection.adminApproveUsername)?"ไม่พบข้อมูล":this.datatransection.adminApproveUsername }}</dd>
          <!-- {{ this.datatransection.bankPaymentTypeId }} {{ this.datatransection.adminApprovePayUsername }} {{ this.datatransection.moneyTranferSlip }} -->
          <dt class="col-sm-3" v-show="this.datatransection.bankPaymentTypeId !== null" v-if="this.datatransection.adminApprovePayUsername !== null && this.datatransection.dataImg !== null">แก้สถานะ :</dt>
          <dd class="col-sm-9" v-show="this.datatransection.bankPaymentTypeId !== null" v-if="this.datatransection.adminApprovePayUsername !== null && this.datatransection.dataImg !== null"> <a class="btn btn-warning" href="javascript: void(0);" @click="reStatusBankPayment()"> ยกเลิกรายการปรับสถานะ {{this.datatransection.bankPaymentId}}</a></dd>

          <dt class="col-sm-3 text-truncate" v-if="this.datatransection.dataImg !== null">สลิปหลักฐาน :</dt>
          <dd class="col-sm-9" v-if="this.datatransection.dataImg !== null">
            <a-upload
              action="#"
              listType="picture-card"
              :fileList="this.datatransection.moneyTranferSlip.fileList"
              style="width: 100%"
              @preview="handlePreview"
            >
            </a-upload>
          </dd>
        </dl>
      </div>
      <div class="text-right" v-if="this.pageType === 'deposit' || this.pageType === 'depositFront'">
        <a class="btn btn-danger" href="javascript: void(0);" @click="cancelStatement(datatransection.depositCode, datatransection.operatorCode)"><i class="fe fe-x mr-1" /> ยกเลิกรายการ</a>
      </div>
    </a-modal>
    <a-modal title="จัดการข้อมูลชุดบัญชีธนาคาร" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk"
        @cancel="handleCancelModel">
        <a-form-model ref="ruleForm" :model="form" :rules="rules">
          <a-form-model-item label="เลือกบัญชี" prop="bankAcountCode">
            <a-select v-model="form.bankAcountCode" placeholder="กรุณาเลือกข้อมูล" >
              <a-select-option v-for="(item , index) in plainOptions" :key="index" :value="item.bankAcountCode">
                  {{ `${item.bankShort}:${item.accountName}(${item.accountNumber})` }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item label="เลือกบัญชี">
            <a-radio-group :options="plainOptions" @change="onChange1" >
              <a-radio-button :value="value">
                {{ plainOptions.label }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item> -->
          <a-form-model-item label="รูป" prop="urlSlip">
            <a-input v-model="form.urlSlip" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { getName } from '@/utils/status'
import apiClient from '@/services/api'
import moment from 'moment'
import momentTz from 'moment-timezone'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
const panes = [
  { title: 'ปกติ', key: '1' },
  { title: 'มีปัญหา', key: '2' },
]
function CopyMe(TextToCopy) {
  var TempText = document.createElement('textarea')
  TempText.value = TextToCopy
  document.body.appendChild(TempText)
  TempText.select()
  document.execCommand('copy')
  document.body.removeChild(TempText)
}

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    data: {
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
    },
  },
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getSelectOperator: 'getSelectOperator',
      getSelectBankService: 'getSelectBankService',
      getSelectStatus: 'getSelectStatus',
      getKeyword: 'getKeyword',
      getKeywordTime: 'getKeywordTime',
      getSearchUpdateStatement: 'getSearchUpdateStatement',
    }),
    myVal() {
      if (this.ctr === 0) {
        this.reCountdown()
      }
      return this.ctr
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = this.dataTable.map((result) => {
                return result.bankPaymentId
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
  },
  watch: {
    getStartDate: function(val) {
      if (val) this.getDataStatement()
    },
    getEndDate: function(val) {
      if (val && !this.checkFistPage) {
        this.getDataStatement()
      }

      if (this.checkFistPage) this.checkFistPage = false
    },
    getSelectOperator: function(val) {
      if (val) this.getDataStatement()
    },
    getSelectBankService: function(val) {
      if (val) this.getDataStatement()
    },
    getSelectStatus: function(val) {
      if (val) this.getDataStatement()
    },
    getKeyword: function(val) {
      if (val) this.getDataStatement(val)
    },
    getKeywordTime: function(val) {
      if (val) {
        this.getDataStatement()
      }
    },
    getSearchUpdateStatement: function(val) {
      if (val) {
        this.getDataStatement()
      }
    },
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
  },
  data() {
    return {
      visible: false,
      checkFistPage: true,
      loadingActive: true,
      json_data: [],
      json_fields: {
        ลำดับ: 'bankPaymentId',
        ชื่อคู่ค้า: 'operatorCode',
        บัญชีระบบ: 'bankServiceSystem',
        เวลาโอน: 'datetimeTranfer',
        เงินเข้า: 'amountInCome',
        เงินออก: 'amountOutCome',
        รายละเอียด: 'detail',
        สถานะ: 'bankPaymentStatus',
        ธนาคารที่โอน: 'detailBankNumber',
        วันที่สร้าง: 'createdAt',
      },
      // fileName: 'สเตทเม้นท์ (' + typename + ')' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
      dataTable: [],
      dataExport: [],
      modelShowDetail: false,
      // modelShowDetail2: false,
      // modelShowDetail3: false,
      // modelShowDetail4: false,
      // modelShowDetail5: false,
      isloading: false,
      loadingTable: false,
      loadingModal: false,
      selectedRowKeys: [],
      // datatransection: {
      //   bankPaymentId: null,
      //   depositCode: null,
      //   amount: null,
      //   userBankTranfer: null,
      //   systemBankTranfer: null,
      //   adminCreateUsername: null,
      //   adminApprovePayUsername: null,
      //   moneyTranferSlip: null,
      //   remark: null,
      //   status: null,
      //   color: null,
      // },
      // datatransection2: {
      //   bankPaymentId: null,
      //   depositCode: null,
      //   amount: null,
      //   userBankTranfer: null,
      //   systemBankTranfer: null,
      //   adminCreateUsername: null,
      //   adminApprovePayUsername: null,
      //   moneyTranferSlip: null,
      //   remark: null,
      //   status: null,
      //   color: null,
      // },
      // datatransection3: {
      //   bankPaymentId: null,
      //   depositCode: null,
      //   amount: null,
      //   remark: null,
      //   dataImg: null,
      //   adminCreateUsername: null,
      //   adminApprovePayUsername: null,
      //   moneyTranferSlip: {
      //     previewVisible: false,
      //     previewImage: '',
      //     fileList: [{
      //       uid: -1,
      //       name: '',
      //       status: 'done',
      //       url: '',
      //     }],
      //   },
      // },
      // datatransection4: {
      //   bankPaymentId: null,
      //   depositCode: null,
      //   amount: null,
      //   remark: null,
      //   userBankTranfer: null,
      //   dataImg: null,
      //   adminCreateUsername: null,
      //   adminApprovePayUsername: null,
      //   moneyTranferSlip: {
      //     previewVisible: false,
      //     previewImage: '',
      //     fileList: [{
      //       uid: -1,
      //       name: '',
      //       status: 'done',
      //       url: '',
      //     }],
      //   },
      //   systemBankTranfer: null,
      //   status: null,
      //   color: null,
      // },
      form: {
        bankPaymentId: null,
        bankAcountCode: null,
        urlSlip: null,
      },
      plainOptions: [],
      datatransection: {
        bankPaymentId: null,
        depositCode: null,
        amount: null,
        remark: null,
        userBankTranfer: null,
        dataImg: null,
        adminCreateUsername: null,
        adminApprovePayUsername: null,
        moneyTranferSlip: {
          previewVisible: false,
          previewImage: '',
          fileList: [{
            uid: -1,
            name: '',
            status: 'done',
            url: '',
          }],
        },
        systemBankTranfer: null,
        status: null,
        color: null,
        statementStatus: null,
        operatorCode: null,
      },
      columns: [
        {
          title: 'ลำดับ',
          key: 'bankPaymentId',
          dataIndex: 'bankPaymentId',
          width: 80,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'bankPaymentId',
          },
          onFilter: (value, record) => record.bankPaymentId.toString().includes(value.toString()),
        },
        {
          title: 'ชื่อคู่ค้า',
          key: 'operatorName',
          dataIndex: 'operatorName',
          width: 100,
          filters: [],
          onFilter: (value, record) => record.operatorName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'บัญชีระบบ',
          key: 'bankServiceSystem',
          dataIndex: 'bankServiceSystem',
          width: 150,
        },
        {
          title: 'เวลาโอน',
          key: 'datetimeTranfer',
          dataIndex: 'datetimeTranfer',
          customRender: (text, row, index) => {
            return momentTz(text).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
          },
          width: 150,
        },
        {
          title: 'เงินเข้า',
          key: 'amountInCome',
          dataIndex: 'amountInCome',
          scopedSlots: { customRender: 'actionAmountInCome' },
          // customRender: (text, row, index) => {
          //   if (text !== '-') {
          //     const amountIncomes = parseFloat(text)
          //     return amountIncomes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          //   }
          //   return text
          // },
          width: 100,
        },
        {
          title: 'เงินออก',
          key: 'amountOutCome',
          dataIndex: 'amountOutCome',
          scopedSlots: { customRender: 'actionAmountOutCome' },
          // customRender: (text, row, index) => {
          //   if (text !== '-') {
          //     const amountOutComes = parseFloat(text)
          //     return amountOutComes.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          //   }
          //   return text
          // },
          width: 100,
        },
        {
          title: 'รายละเอียด',
          key: 'detail',
          dataIndex: 'detail',
          scopedSlots: {
            customRender: 'detail',
          },
          width: 100,
        },
        {
          title: 'สถานะ',
          filters: [],
          onFilter: (value, record) => record.filtersStatus.toString().includes(value.toString()),
          // onFilter: (value, record) => record.filtersStatus.toString().includes(value.toString()),
          key: 'status',
          dataIndex: 'bankPaymentStatus',
          scopedSlots: {
            customRender: 'status',
          },
          width: 130,
          fixed: 'right',
        },
        {
          title: 'ธนาคารที่โอน',
          key: 'detailBankNumber',
          dataIndex: 'detailBankNumber',
          width: 250,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'detailBankNumber',
          },
          onFilter: (value, record) => record.detailBankNumber.toLowerCase().includes(value.toLowerCase()),
          fixed: 'right',
        },
        {
          title: 'วันที่สร้าง',
          key: 'createdAt',
          dataIndex: 'createdAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',
        },
        {
          title: 'วันที่อัปเดท',
          key: 'updatedAt',
          dataIndex: 'updatedAt',
          width: 100,
          customRender: (text, row, index) => {
            return momentTz(text).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
          },
          fixed: 'right',

        },
      ],
      refresh: false,
      countdown: false,
      counters: '',
      counters2: '',
      ctr: 5,
      statusKey: 1,
      activeKey: panes[0].key,
      panes,
      rules: {
        bankAcountCode: [
          { required: true, message: 'กรุณาเลือกบัญชี', trigger: 'change' },
        ],
        urlSlip: [
          { required: true, message: 'กรุณากรอกรูป', trigger: 'blur' },
        ],
      },
    }
  },
  props: [
    'pageType',
    'withdrawType',
  ],
  methods: {
    cancelStatement(depositCode, operatorCode) {
      // const CurrentDate = moment().unix()
      if (depositCode && operatorCode) {
        Swal.fire({
          icon: 'info',
          title: 'แน่ใจหรือไม่ที่ต้องการยกเลิกสเตทเม้น #' + depositCode,
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          preConfirm: (value) => {
            if (value) {
              // ส่งข้อมูลอัปเดทสถานะ
              const data = {
                // sendTimeAt: CurrentDate,
                depositCode: depositCode,
                operatorCode: operatorCode,
              }
              return apiClient.post('/statement/cancelDeposit', data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                    `Request failed: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.useModal()
            this.getDataStatement()
          }
        })
      }
    },
    reStatusBankPayment() {
      const bankPaymentId = this.datatransection.bankPaymentId
      if (bankPaymentId) {
        Swal.fire({
          icon: 'info',
          title: 'แน่ใจหรือไม่ที่ต้องการยกเลิกสถานะ #' + bankPaymentId,
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          preConfirm: (value) => {
            if (value) {
              // ส่งข้อมูลอัปเดทสถานะ
              const data = {
                bankPaymentId: bankPaymentId,
              }
              return apiClient.post('/statement/reSetPaymentRemark', data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                    `Request failed: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.useModal()
            this.getDataStatement()
          }
        })
      }
    },
    getNameExport (type) {
      if (type === 'default') {
        return 'สเตทเม้นท์ (บัญชีถอนเงิน)' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY')
      } else if (type === 'refund') {
        return 'สเตทเม้นท์ (บัญชีถอนเงินคืนลูกค้า)' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY')
      } else if (type === 'commission') {
        return 'สเตทเม้นท์ (บัญชีถอนคอมมิชชั่น)' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY')
      } else if (type === 'atm') {
        return 'สเตทเม้นท์ (บัญชีกดตู้)' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY')
      } else {
        return 'สเตทเม้นท์ (บัญชีฝากเงิน)' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY')
      }
    },
    checkDataExcel (data) {
      if (data.length === 0) {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการ Export' })
        return false
      }
    },
    dataToExcel (data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.bankPaymentId === result) {
              return true
            }
          })
          const resultData = {
            bankPaymentId: item.bankPaymentId,
            operatorCode: item.operatorCode,
            bankServiceSystem: item.bankServiceSystem,
            datetimeTranfer: moment(item.datetimeTranfer).format('DD/MM/YYYY HH:mm:ss'),
            amountInCome: item.amountInCome,
            amountOutCome: item.amountOutCome,
            detail: item.detail,
            bankPaymentStatus: this.getStatus('bankPayment', item.bankPaymentStatus).name,
            detailBankNumber: item.detailBankNumber,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          dataresult.push(resultData)
        })
        this.json_data = dataresult
      }
    },
    exportAll (obj) {
      this.dataExport = []
      let resultData = {}
      obj.map(element => {
        resultData = {
          bankPaymentId: element.bankPaymentId,
          operatorCode: element.operatorCode,
          bankServiceSystem: element.bankServiceSystem,
          datetimeTranfer: moment(element.datetimeTranfer).format('DD/MM/YYYY HH:mm:ss'),
          amountInCome: element.amountInCome,
          amountOutCome: element.amountOutCome,
          detail: element.detail,
          bankPaymentStatus: this.getStatus('bankPayment', element.bankPaymentStatus).name,
          detailBankNumber: element.detailBankNumber,
          createdAt: moment(element.createdAt).format('DD/MM/YYYY HH:mm:ss'),
        }
        this.dataExport.push(resultData)
      })
    },
    onCopy: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.bankPaymentId === result) {
              return true
            }
          })
          const resultData = {
            bankPaymentId: item.bankPaymentId,
            operatorCode: item.operatorCode,
            bankServiceSystem: item.bankServiceSystem,
            datetimeTranfer: moment(item.datetimeTranfer).format('DD/MM/YYYY HH:mm:ss'),
            amountInCome: item.amountInCome,
            amountOutCome: item.amountOutCome,
            detail: item.detail,
            bankPaymentStatus: this.getStatus('bankPayment', item.bankPaymentStatus).name,
            detailBankNumber: item.detailBankNumber,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onError: function (e) {
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    handleCancel () {
      this.previewVisible = false
    },
    handlePreview (file) {
      this.previewImage = file.url || file.thumbUrl
      window.open(this.previewImage, '_blank')
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    callback(key) {
      if (key === '1') {
        this.statusKey = 1
        this.getDataStatement()
      } else {
        this.statusKey = 2
        this.getDataStatement()
      }
    },
    useModal(e) {
      this.modelShowDetail = !this.modelShowDetail
    },
    // useModal2(e) {
    //   this.modelShowDetail2 = !this.modelShowDetail2
    // },
    // useModal3(e) {
    //   this.modelShowDetail3 = !this.modelShowDetail3
    // },
    // useModal4(e) {
    //   this.modelShowDetail4 = !this.modelShowDetail4
    // },
    // useModal5(e) {
    //   this.modelShowDetail5 = !this.modelShowDetail5
    // },
    async getDataStatement() {
      const dataStatement = {
        bankType: this.pageType,
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        operatorCode: this.getSelectOperator,
        bankServiceId: this.getSelectBankService,
        status: this.getSelectStatus,
        keyword: this.getKeyword,
        statusKey: this.statusKey,
        keywordTime: this.getKeywordTime,
        searchUpdate: this.getSearchUpdateStatement,
      }
      // console.log(this.getSearchUpdateStatement)
      this.loadingTable = !this.loadingTable
      if (this.withdrawType) dataStatement.withdrawType = this.withdrawType

      await apiClient.post('/statement/getData', dataStatement).then(response => {
        this.loadingTable = !this.loadingTable
        const res = response.data
        if (res.code === '000') {
          this.dataTable = res.responseData.data
          this.exportAll(res.responseData.data)
          if (this.dataTable.length > 0) {
            const listOperater = this.dataTable.map(function(item, pos) {
              return { text: item.operatorName, value: item.operatorName }
            })
            this.columns[1].filters = [
              ...new Map(listOperater.map((item) => [item.text, item])).values(),
            ]
            // this.columns[7].filters = [
            //   ...new Map(liststatus.map((item) => [item.text, item])).values(),
            // ]
          }
          if (this.statusKey === 1) {
            this.columns[7].filters = [{ text: 'ทำรายการสำเร็จ', value: 1 },
              { text: 'รายการใหม่', value: 2 },
              { text: 'ตรวจสอบจับคู่รายการ', value: 3 },
              { text: 'สร้างมือ', value: 6 },
              { text: 'แนปสลิป', value: 7 },
              { text: 'สร้างมือ/แนปสลิป', value: 8 }]
          } else {
            this.columns[7].filters = [{ text: 'รายการมีปัญหา', value: 4 },
              { text: 'รายการผี', value: 5 },
              { text: 'สร้างมือ', value: 9 },
              { text: 'แนปสลิป', value: 10 },
              { text: 'สร้างมือ/แนปสลิป', value: 11 }]
          }
        }
      })
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    useAction(bankPaymentId, status) {
      if (status === '000' || status === '005') this.showSucces(bankPaymentId)
      if (status === '003' || status === '004') this.showInfo(bankPaymentId)
    },
    showInfo(bankPaymentId) {
      Swal.fire({
        icon: 'info',
        title: 'ต้องการเปลี่ยนสถานะหรือต้องการจัดการสเตทเม้นท์หรือใส่หมายเหตุ?',
        showDenyButton: true,
        showCancelButton: true,
        showChangeButton: true,
        confirmButtonText: 'เปลี่ยนสถานะ',
        denyButtonText: 'จัดการสเตทเม้นท์',
        denyButtonColor: '#17a2b8',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.reStatus(bankPaymentId, '001')
        } else if (result.isDenied) {
          this.mangeStatement(bankPaymentId)
          // this.showEdit(bankPaymentId, '000')
        }
      })
    },
    mangeStatement(bankPaymentId) {
      Swal.fire({
        icon: 'info',
        title: 'ต้องการจับคู่เติมเงินมือหรือต้องการแนบหลักฐาน?',
        showDenyButton: true,
        showCancelButton: true,
        showChangeButton: true,
        confirmButtonText: 'จับคู่เติมเงินมือ',
        denyButtonText: 'แนบหลักฐาน',
        denyButtonColor: '#17a2b8',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.changeAccount(bankPaymentId, '001')
        } else if (result.isDenied) {
          this.showCheckEdit(bankPaymentId)
          // this.showEdit(bankPaymentId, '000')
        }
      })
    },
    async changeAccount(bankPaymentId) {
      const data = {
        bankPaymentId: bankPaymentId,
      }
      this.form = {
        bankPaymentId: null,
        bankAcountCode: null,
        urlSlip: null,
      }
      await apiClient.post('/statement/getUserbankStatment', data).then(response => {
        if (response.data.code === '000') {
          this.plainOptions = response.data.responseData.data
          this.form.bankPaymentId = bankPaymentId
          // this.plainOptions = response.data.responseData.data.map(function(item, pos) {
          //   return { label: `${item.bankShort}:${item.accountName}(${item.accountNumber})`, value: item.bankAcountCode }
          // })
        }
        this.visible = !this.visible
      }).catch(error => {
        Swal.showValidationMessage(
            `Request failed: ${error}`,
        )
      })
    },
    handleOk(e) {
      this.confirmLoading = true
      this.onSubmit()
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          Swal.fire({
            icon: 'info',
            title: 'แน่ใจหรือไม่ที่ต้องการจับคู่เติมเงินมือ',
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                // ส่งข้อมูลอัปเดทสถานะ
                return apiClient.post('statement/confirmStatmentManual', this.form).then(response => {
                  if (response.status !== 200) {
                    throw new Error(response.message)
                  }
                  return response.data
                }).catch(error => {
                  Swal.showValidationMessage(
                      `เกิดข้อผิดพลาด: ${error}`,
                  )
                })
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({
                icon: iconError,
                title: result.value.message,
              })
              this.visible = false
              this.getDataStatement()
            }
          })
        }
      })
    },
    handleCancelModel(e) {
      this.visible = false
    },
    async showSucces(bankPaymentId, amount) {
      const dataTransection = {
        bankPaymentId: bankPaymentId,
        dataType: this.pageType,
      }
      if (this.pageType === 'deposit' || this.pageType === 'withdraw' || this.pageType === 'depositFront' || this.pageType === 'withdrawFront') {
        this.loadingModal = !this.loadingModal
        this.loadingActive = true
        this.useModal()
      }
      // if (this.withdrawType === 'commission') {
      //   this.loadingModal = !this.loadingModal
      //   this.loadingActive = true
      //   this.useModal2()
      // } else if (this.pageType === 'refund') {
      //   this.loadingModal = !this.loadingModal
      //   this.loadingActive = true
      //   this.useModal4()
      // } else {
      //   this.loadingModal = !this.loadingModal
      //   this.loadingActive = true
      //   this.useModal3()
      // }
      // if (this.pageType === 'bankPayment') {
      //   this.loadingModal = !this.loadingModal
      //   this.loadingActive = true
      //   this.useModal5()
      // }
      // this.loadingModal = !this.loadingModal
      await apiClient.post('/statement/getTransection', dataTransection).then(response => {
        // this.loadingModal = !this.loadingModal
        // this.datatransection = {
        //   bankPaymentId: null,
        //   depositCode: null,
        //   amount: null,
        //   userBankTranfer: null,
        //   systemBankTranfer: null,
        //   adminCreateUsername: null,
        //   adminApprovePayUsername: null,
        //   moneyTranferSlip: null,
        //   remark: null,
        //   status: null,
        //   color: null,
        // }
        // this.datatransection2 = {
        //   bankPaymentId: null,
        //   depositCode: null,
        //   amount: null,
        //   userBankTranfer: null,
        //   systemBankTranfer: null,
        //   adminCreateUsername: null,
        //   adminApprovePayUsername: null,
        //   moneyTranferSlip: null,
        //   remark: null,
        //   status: null,
        //   color: null,
        // }
        // this.datatransection3 = {
        //   bankPaymentId: null,
        //   depositCode: null,
        //   amount: null,
        //   remark: null,
        //   dataImg: null,
        //   adminCreateUsername: null,
        //   adminApprovePayUsername: null,
        //   moneyTranferSlip: {
        //     previewVisible: false,
        //     previewImage: '',
        //     fileList: [{
        //       uid: -1,
        //       name: '',
        //       status: 'done',
        //       url: '',
        //     }],
        //   },
        //   systemBankTranfer: null,
        //   status: null,
        //   color: null,
        // }

        this.datatransection = {
          bankPaymentId: null,
          depositCode: null,
          amount: null,
          remark: null,
          dataImg: null,
          userBankTranfer: null,
          adminCreateUsername: null,
          adminApproveUsername: null,
          adminApprovePayUsername: null,
          moneyTranferSlip: {
            previewVisible: false,
            previewImage: '',
            fileList: [{
              uid: -1,
              name: '',
              status: 'done',
              url: '',
            }],
          },
          systemBankTranfer: null,
          status: null,
          color: null,
          statementStatus: null,
          operatorCode: null,
          bankPaymentTypeId: null,
        }

        const res = response.data
        if (res.code === '000') {
          const getData = res.responseData.data[0]

          if (getData.bankPaymentStatus === '000') {
            if (getData.statementStatus === 'deposit' || getData.statementStatus === 'withdraw' || getData.statementStatus === 'depositFront' || getData.statementStatus === 'withdrawFront') {
              // this.useModal()
              this.loadingModal = !this.loadingModal
              this.loadingActive = !this.loadingActive
              const getnameStatus = getName(this.pageType, getData.transectionStatus)
              this.datatransection = {
                bankPaymentId: bankPaymentId,
                depositCode: getData.transectionCode,
                amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
                userBankTranfer: getData.bankServiceUser,
                systemBankTranfer: getData.bankServiceSystem,
                adminCreateUsername: getData.adminCreateUsername,
                adminApprovePayUsername: getData.adminApprovePayUsername,
                adminApproveUsername: getData.adminApproveUsername,
                remark: getData.bankPaymentRemark,
                dataImg: getData.moneyTranferSlip,
                moneyTranferSlip: {
                  previewVisible: false,
                  previewImage: '',
                  fileList: [{
                    uid: -1,
                    name: '',
                    status: 'done',
                    url: getData.moneyTranferSlip,
                  }],
                },
                status: getnameStatus[0].name,
                color: getnameStatus[0].color,
                statementStatus: this.pageType,
                operatorCode: getData.operatorCode,
                bankPaymentTypeId: getData.bankPaymentTypeId,
              }
            } else if (getData.statementStatus === 'tranfer') {
              // console.log(this.pageType, getData.bankPaymentStatus)
              // this.useModal2()
              const getnameStatus2 = getName(this.pageType, getData.bankPaymentStatus)

              this.datatransection = {
                bankPaymentId: bankPaymentId,
                depositCode: getData.tranferId,
                amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
                userBankTranfer: getData.bankTranferSystem,
                systemBankTranfer: getData.bankServiceSystem,
                adminCreateUsername: getData.adminCreateUsername,
                adminApprovePayUsername: getData.adminApprovePayUsername,
                remark: getData.bankPaymentRemark,
                dataImg: null,
                moneyTranferSlip: {
                  previewVisible: false,
                  previewImage: '',
                  fileList: [{
                    uid: -1,
                    name: '',
                    status: 'done',
                    url: '',
                  }],
                },
                status: getnameStatus2[0].name,
                color: getnameStatus2[0].color,
                statementStatus: getData.statementStatus,
              }
              this.loadingModal = !this.loadingModal
              this.loadingActive = !this.loadingActive
              // console.log(this.datatransection2)
            } else if (getData.statementStatus === 'refund') {
              // this.useModal4()
              const getnameStatus4 = getName(this.pageType, getData.bankPaymentStatus)
              this.datatransection = {
                bankPaymentId: bankPaymentId,
                depositCode: getData.refundCode,
                amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
                remark: getData.remark,
                userBankTranfer: getData.bankServiceUser,
                systemBankTranfer: getData.bankServiceSystem,
                dataImg: getData.slip,
                adminCreateUsername: getData.adminCreatedUsername,
                adminApprovePayUsername: getData.adminApprovePayUsername,
                moneyTranferSlip: {
                  previewVisible: false,
                  previewImage: '',
                  fileList: [{
                    uid: -1,
                    name: 'ไม่พบไฟล์',
                    status: 'done',
                    url: getData.slip,
                  }],
                },
                status: getnameStatus4[0].name,
                color: getnameStatus4[0].color,
                statementStatus: getData.statementStatus,
              }
              this.loadingModal = !this.loadingModal
              this.loadingActive = !this.loadingActive
            } else {
              // this.useModal3()
              const getnameStatus3 = getName(this.pageType, getData.bankPaymentStatus)
              this.datatransection = {
                bankPaymentId: bankPaymentId,
                depositCode: getData.tranferId,
                amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
                remark: getData.remark,
                dataImg: getData.moneyTranferSlip,
                systemBankTranfer: getData.bankServiceSystem,
                adminCreateUsername: getData.adminCreateUsername,
                adminApprovePayUsername: getData.adminApprovePayUsername,
                moneyTranferSlip: {
                  previewVisible: false,
                  previewImage: '',
                  fileList: [{
                    uid: -1,
                    name: 'ไม่พบไฟล์',
                    status: 'done',
                    url: getData.moneyTranferSlip,
                  }],
                },
                status: getnameStatus3[0].name,
                color: getnameStatus3[0].color,
                statementStatus: getData.statementStatus,
              }
              this.loadingModal = !this.loadingModal
              this.loadingActive = !this.loadingActive
            }
          } else if (getData.bankPaymentStatus === '005') {
            const getnameStatus3 = getName(this.pageType, getData.bankPaymentStatus)
            this.datatransection = {
              bankPaymentId: bankPaymentId,
              depositCode: getData.tranferId,
              amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
              remark: getData.remark,
              dataImg: getData.moneyTranferSlip,
              systemBankTranfer: getData.bankServiceSystem,
              adminCreateUsername: getData.adminCreateUsername,
              adminApprovePayUsername: getData.adminApprovePayUsername,
              moneyTranferSlip: {
                previewVisible: false,
                previewImage: '',
                fileList: [{
                  uid: -1,
                  name: 'ไม่พบไฟล์',
                  status: 'done',
                  url: getData.moneyTranferSlip,
                }],
              },
              status: getnameStatus3[0].name,
              color: getnameStatus3[0].color,
              statementStatus: getData.statementStatus,
            }
            this.loadingModal = !this.loadingModal
            this.loadingActive = !this.loadingActive
          } else {
            // this.useModal5()
            const getnameStatus5 = getName('bankPayment', getData.bankPaymentStatus)

            this.datatransection5 = {
              bankPaymentId: bankPaymentId,
              depositCode: getData.tranferId,
              amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
              remark: getData.remark,
              dataImg: getData.moneyTranferSlip,
              systemBankTranfer: getData.bankServiceSystem,
              adminCreateUsername: getData.adminCreateUsername,
              adminApprovePayUsername: getData.adminApprovePayUsername,
              moneyTranferSlip: {
                previewVisible: false,
                previewImage: '',
                fileList: [{
                  uid: -1,
                  name: 'ไม่พบไฟล์',
                  status: 'done',
                  url: getData.moneyTranferSlip,
                }],
              },
              status: getnameStatus5[0].name,
              color: getnameStatus5[0].color,
              statementStatus: 'bankPayment',
            }
            this.loadingModal = !this.loadingModal
            this.loadingActive = !this.loadingActive
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `Request failed: ${error}`,
        )
      })
    },
    async showCheckEdit(bankPaymentId) {
      Swal.fire({
        icon: 'info',
        title: 'กรุณาเลือกตัวเลือก?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'เพิ่มหมายเหตุ (ไม่ปรับสถานะ)',
        denyButtonText: 'แนบหลักฐาน (ปรับสถานะ)',
        denyButtonColor: '#17a2b8',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.showAddRemark(bankPaymentId)
        } else if (result.isDenied) {
          this.showEdit(bankPaymentId, '000')
        }
      })
    },
    async getBankPaymentType() {
      return apiClient.get('/statement/getPaymentType').then(response => {
        if (response.status !== 200) {
          throw new Error(response.message)
        }
        return response.data
      }).catch(error => {
        Swal.showValidationMessage(
          `Request failed: ${error}`,
        )
      })
    },
    async showAddRemark(bankPaymentId) {
      const { value: formValues } = await Swal.fire({
        title: 'กรุณากรอกหมายเหตุ *กรณีนี้จะไม่เปลี่ยนสถานะ',
        html:
          '<textarea id="remark" class="swal2-input" placeholder="หมายเหตุ"></textarea>',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        preConfirm: (value) => {
          if (value) {
            const remark = document.getElementById('remark').value

            if (remark === '') {
              Swal.showValidationMessage(
                'กรุณากรอกข้อมูล',
              )
            }

            return [remark]
          }
          return [
            document.getElementById('remark').value,
          ]
        },
        allowOutsideClick: () => !Swal.isLoading(),
      })

      if (formValues) {
        Swal.fire({
          title: 'กรุณาตรวจสอบข้อมูล!',
          text: `หมายเหตุ : ${formValues[0]}`,
          imageWidth: 250,
          imageHeight: 250,
          imageAlt: 'Custom image',
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          preConfirm: (value) => {
            if (value) {
              // ส่งข้อมูลอัปเดทสถานะ
              const data = {
                bankPaymentId: bankPaymentId,
                remark: formValues[0],
              }

              return apiClient.post('/statement/setRemark', data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.getDataStatement()
          }
        })
      }
    },
    async showEdit(bankPaymentId, statusCode) {
      const bankPaymentType = await this.getBankPaymentType()
      const dataBankPayment = bankPaymentType.responseData.data
      const dataOption = dataBankPayment
      const option = {}
      dataOption.forEach(o => {
        option[o.id] = o.name
      })
      const { value: formValues } = await Swal.fire({
        title: 'กรุณากรอกหมายเหตุ และ ลิ้งที่อยู่ของรูปสลิปหลักฐาน',
        input: 'select',
        inputOptions: option,
        inputPlaceholder: 'เลือกประเภทสเตทเม้น',
        html:
          '<textarea id="remark" class="swal2-input" placeholder="หมายเหตุ"></textarea>' +
          '<input id="slip" class="swal2-input" placeholder="สลิปหลักฐาน"></input>',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        preConfirm: (value) => {
          if (value) {
            const remark = document.getElementById('remark').value
            const slip = document.getElementById('slip').value
            const bankPaymentType = value
            // console.log(bankPaymentType)
            if (remark === '' || slip === '' || bankPaymentType === '') {
              Swal.showValidationMessage(
                'กรุณากรอกข้อมูล',
              )
            }

            return [remark, slip, bankPaymentType]
          }
          return [
            document.getElementById('remark').value,
            document.getElementById('slip').value,
            value,
          ]
        },
        allowOutsideClick: () => !Swal.isLoading(),
      })

      if (formValues) {
        Swal.fire({
          title: 'กรุณาตรวจสอบข้อมูล!',
          html: `
            หมายเหตุ : ${formValues[0]} <br>
            ประเภท : ${option[formValues[2]]}
          `,
          imageUrl: `${formValues[1]}`,
          imageWidth: 250,
          imageHeight: 250,
          imageAlt: 'Custom image',
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          preConfirm: (value) => {
            if (value) {
              // ส่งข้อมูลอัปเดทสถานะ
              const data = {
                bankPaymentId: bankPaymentId,
                statusCode: statusCode,
                remark: formValues[0],
                slip: formValues[1],
                bankPaymentType: formValues[2],
              }

              return apiClient.post('/statement/setStatusCode', data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.getDataStatement()
          }
        })
      }
    },
    async reStatus(bankPaymentId, statusCode) {
      await Swal.fire({
        title: 'แน่ใจหรือไม่ที่ต้องการเปลี่ยนสถานะรายการนี้',
        icon: 'question',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showCancelButton: true,
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            const data = { bankPaymentId: bankPaymentId, statusCode: statusCode }
            return apiClient.post('/statement/reStatusCode', data).then(response => {
              if (response.status !== 200) {
                throw new Error(response.message)
              }
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                `Request failed: ${error}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.getDataStatement()
        }
      })
    },
    editStatement(bankPaymentId, slip, remark, statusCode) {

    },
    setComma(value) {
      if (value > 0 && value !== null) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return '-'
      }
    },
    setColor(value) {
      if (value === 'amountIn') {
        return 'color: #14ab84'
      } else {
        return 'color: #f04e3f'
      }
    },
    getAutoRefresh(refresh) {
      if (!refresh) {
        this.refresh = true
        this.ReloadData(true)
      } else {
        this.refresh = false
        this.ReloadData(false)
      }
    },
    ReloadData (value) {
      if (value) {
        this.countdown = true
        this.counters = setInterval(function () {
          this.getDataStatement()
        }.bind(this), 5000)
        this.counters2 = setInterval(function () {
          this.ctr = this.ctr - 1
        }.bind(this), 1000)
      } else {
        clearInterval(this.counters)
        clearInterval(this.counters2)
        this.ctr = 5
      }
    },
    reCountdown () {
      this.ctr = 5
    },
  },
  async created() {
    // console.log('yes');
    // await this.getDataStatement()
  },
}
</script>

<style>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {

    color: #666;
  }
  i.anticon.anticon-delete {
    display: none;
  }
 [data-kit-theme="default"] .ant-upload-list-picture-card .ant-upload-list-item {
    float: left;
    width: 300px;
    height: 160px;
    margin: 0 8px 8px 0;
}
</style>
